import React, { useEffect, useMemo } from "react";
import { useQuery } from "@apollo/client";
import LoadingBoundary from "../../ui_atoms/LoadingBoundary";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../../navigations/RootNavigation";
import { Linking, View } from "react-native";
import VStack from "../../ui_atoms/VStack";
import Gap from "../../ui_atoms/Gap";
import { GET_CLIENT_INFO } from "../../graphql/core";
import { ClientInfo } from "../../__generated__/graphql";
import ListItem from "../../ui_atoms/ListItem";
import UserAvatar from "../user/UserAvatar";
import ListTitle from "../../ui_atoms/ListTitle";
import { useNavigation } from "@react-navigation/native";
import SimplePageContent from "../../components/SimplePageContent";

const ClientHeader: React.FC<{ clientInfo: ClientInfo }> = ({ clientInfo }) => {
    return (
        <View style={{ width: "100%", alignItems: "center" }}>
            <UserAvatar avatarPath={clientInfo.logoUrl} size={100} />
        </View>
    );
};

type ScreenParams = StackScreenProps<RootStackParamList>;
type Props = StackScreenProps<RootStackParamList, "ClientDetails">;

const ClientDetailsScreen: React.FC<Props> = ({ route }) => {
    const navigation = useNavigation<ScreenParams["navigation"]>();
    const { loading, error, data, refetch } = useQuery(GET_CLIENT_INFO, {
        variables: { clientProfileId: route?.params?.clientProfileId || "" },
        fetchPolicy: "cache-and-network",
    });
    const clientInfo = useMemo(() => data?.getClientInfo, [data]);
    useEffect(() => {
        navigation.setOptions({
            title: clientInfo?.name || "",
        });
    }, [clientInfo, navigation]);
    return (
        <SimplePageContent refresh={refetch}>
            <LoadingBoundary loading={loading && !data} error={error}>
                {clientInfo && (
                    <VStack>
                        <Gap gap={1} />
                        <ClientHeader clientInfo={clientInfo} />
                        <Gap gap={2} />
                        <ListTitle value={clientInfo.name} />

                        <ListItem
                            key="profileName"
                            avatarPath={clientInfo?.avatarUrl}
                            description={clientInfo.profileName}
                        />

                        <ListItem
                            key="phone"
                            icon="phone-call"
                            description={clientInfo.phoneNumber || ""}
                            onPress={() => {
                                if (clientInfo.phoneNumber) {
                                    void Linking.openURL(`tel:${clientInfo.phoneNumber}`);
                                }
                            }}
                            rightIcon="phone-call"
                            rightActionMode="action"
                        />

                        <ListItem
                            key="email"
                            icon="email"
                            description={clientInfo.email || ""}
                            onPress={() => {
                                if (clientInfo.email) {
                                    void Linking.openURL(`mailto:${clientInfo.email}`);
                                }
                            }}
                            rightIcon="external-link"
                            rightActionMode="action"
                        />
                    </VStack>
                )}
            </LoadingBoundary>
        </SimplePageContent>
    );
};

export default ClientDetailsScreen;
